module.exports = __webpack_public_path__ + "static/media/GCloud.9bf09372.pdf";